import {Account, useUpdateAccountMutation} from 'api';
import React, {useEffect, useRef, useState} from 'react';

interface Props {
  account: Account;
}

export default ({account}: Props) => {
  const [updateAccount] = useUpdateAccountMutation({
    refetchQueries: ['activitiesByProspectPool'],
  });
  const [address, setAddress] = useState(account.address);
  const ref = useRef(null);

  useEffect(() => {
    ref.current.value = account.address;
  }, [account]);

  return (
    <textarea
      defaultValue={address}
      className="w-60 h-7 rounded hover:border hover:border-border focus:border focus:border-border"
      onChange={(e) => setAddress(e.target.value)}
      onBlur={(e) =>
        updateAccount({
          variables: {
            id: account.id,
            attributes: {
              address: e.target.value,
            },
          },
        })
      }
      ref={ref}
    />
  );
};
